import {
  GetDipByRegionListRequest,
  GetDipByRegionListResponse,
  dataListRestResource,
} from ".";
import { useRestResourceHook } from "../use-rest-resource-hook";
import { GetDipsRequest } from "./get-dips/GetDipsRequest";
import { GetDipsResponse } from "./get-dips/GetDipsResponse";
import { GetEdhNotificationTypeListRequest } from "./get-edh-notification-type-list/GetEdhNotificationTypeListRequest";
import { GetEdhNotificationTypeListResponse } from "./get-edh-notification-type-list/GetEdhNotificationTypeListResponse";
import { GetEdhProtocolListRequest } from "./get-edh-protocol-list/GetEdhProtocolListRequest";
import { GetEdhProtocolListResponse } from "./get-edh-protocol-list/GetEdhProtocolListResponse";
import { GetEdiChainTypeListResponse } from "./get-edi-chain-type-list/GetEdiChainTypeListResponse";
import { GetEdiChainTypeListRequest } from "./get-edi-chain-type-list/GetEdiChainTypeListRequest";
import { GetGeneralCodesRequest } from "./get-general-codes/GetGeneralCodesRequest";
import { GetGeneralCodesResponse } from "./get-general-codes/GetGeneralCodesResponse";
import { GetRoleCodeListRequest } from "./get-role-code-list/GetRoleCodeListRequest";
import { GetRoleCodeListResponse } from "./get-role-code-list/GetRoleCodeListResponse";
import { GetTeamCodeListRequest } from "./get-team-code-list/GetTeamCodeListRequest";
import { GetTeamCodeListResponse } from "./get-team-code-list/GetTeamCodeListResponse";
import { GetUsersRequest } from "./get-users/GetUsersRequest";
import { GetUsersResponse } from "./get-users/GetUsersResponse";
import { GetEdhProtocolFlagUsageListRequest } from "./get-edh-protocol-flag-usage-list/GetEdhProtocolFlagUsageListRequest";
import { GetEdhProtocolFlagUsageListResponse } from "./get-edh-protocol-flag-usage-list/GetEdhProtocolFlagUsageListResponse";
import { GetIfStartMethodEdhProtocolListRequest } from "./get-if-start-method-edh-protocol-list/GetIfStartMethodEdhProtocolListRequest";
import { GetIfStartMethodEdhProtocolListResponse } from "./get-if-start-method-edh-protocol-list/GetIfStartMethodEdhProtocolListResponse";
import { GetEdhProtocolCombinationListRequest } from "./get-edh-protocol-combination-list/GetEdhProtocolCombinationListRequest";
import { GetEdhProtocolCombinationListResponse } from "./get-edh-protocol-combination-list/GetEdhProtocolCombinationListResponse";
import { GetLoginUserRoleListRequest } from "./get-login-user-role-list/GetLoginUserRoleListRequest";
import { GetLoginUserRoleListResponse } from "./get-login-user-role-list/GetLoginUserRoleListResponse";
import { GetDipEnvironmentStateManagementListRequest } from "./get-dip-environment-state-management-list/GetDipEnvironmentStateManagementListRequest";
import { GetDipEnvironmentStateManagementListResponse } from "./get-dip-environment-state-management-list/GetDipEnvironmentStateManagementListResponse";
import { GetIfItemListRequest } from "./get-if-item-list/GetIfItemListRequest";
import { GetIfItemListResponse } from "./get-if-item-list/GetIfItemListResponse";
import { GetComponentAttributeListRequest } from "./get-component-attribute-list/GetComponentAttributeListRequest";
import { GetComponentAttributeListResponse } from "./get-component-attribute-list/GetComponentAttributeListResponse";

export const useGetGeneralCodes = () =>
  useRestResourceHook<GetGeneralCodesRequest, GetGeneralCodesResponse>(
    (request) => dataListRestResource.getGeneralCodes(request),
  );

export const useGetEdiChainTypeList = () =>
  useRestResourceHook<GetEdiChainTypeListRequest, GetEdiChainTypeListResponse>(
    (request) => dataListRestResource.getEdiChainTypeList(request),
  );

export const useGetEdhProtocolList = () =>
  useRestResourceHook<GetEdhProtocolListRequest, GetEdhProtocolListResponse>(
    (request) => dataListRestResource.getEdhProtocolList(request),
  );

export const useGetEdhNotificationTypeList = () =>
  useRestResourceHook<
    GetEdhNotificationTypeListRequest,
    GetEdhNotificationTypeListResponse
  >((request) => dataListRestResource.getEdhNotificationTypeList(request));

export const useGetDips = () =>
  useRestResourceHook<GetDipsRequest, GetDipsResponse>((request) =>
    dataListRestResource.getDips(request),
  );

export const useGetDipByRegionList = () =>
  useRestResourceHook<GetDipByRegionListRequest, GetDipByRegionListResponse>(
    (request) => dataListRestResource.getDipByRegionList(request),
  );

export const useGetRoleCodeList = () =>
  useRestResourceHook<GetRoleCodeListRequest, GetRoleCodeListResponse>(
    (request) => dataListRestResource.getRoleCodeList(request),
  );

export const useGetTeamCodeList = () =>
  useRestResourceHook<GetTeamCodeListRequest, GetTeamCodeListResponse>(
    (request) => dataListRestResource.getTeamCodeList(request),
  );

export const useGetUsers = () =>
  useRestResourceHook<GetUsersRequest, GetUsersResponse>((request) =>
    dataListRestResource.getUsers(request),
  );
export const useGetIfStartMethodEdhProtocolList = () =>
  useRestResourceHook<
    GetIfStartMethodEdhProtocolListRequest,
    GetIfStartMethodEdhProtocolListResponse
  >((request) => dataListRestResource.getIfStartMethodEdhProtocolList(request));

export const useGetEdhProtocolFlagUsageList = () =>
  useRestResourceHook<
    GetEdhProtocolFlagUsageListRequest,
    GetEdhProtocolFlagUsageListResponse
  >((request) => dataListRestResource.getEdhProtocolFlagUsageList(request));

export const useGetEdhProtocolCombinationList = () =>
  useRestResourceHook<
    GetEdhProtocolCombinationListRequest,
    GetEdhProtocolCombinationListResponse
  >((request) => dataListRestResource.getEdhProtocolCombinationList(request));

export const useGetLoginUserRoleList = () =>
  useRestResourceHook<
    GetLoginUserRoleListRequest,
    GetLoginUserRoleListResponse
  >((request) => dataListRestResource.getLoginUserRoleList(request));

export const useGetDipEnvironmentStateManagementList = () =>
  useRestResourceHook<
    GetDipEnvironmentStateManagementListRequest,
    GetDipEnvironmentStateManagementListResponse
  >((request) =>
    dataListRestResource.getDipEnvironmentStateManagementList(request),
  );

export const useGetIfItemList = () =>
  useRestResourceHook<GetIfItemListRequest, GetIfItemListResponse>((request) =>
    dataListRestResource.getIfItemList(request),
  );

export const useGetComponentAttributeList = () =>
  useRestResourceHook<
    GetComponentAttributeListRequest,
    GetComponentAttributeListResponse
  >((request) => dataListRestResource.getComponentAttributeList(request));
